import { render, staticRenderFns } from "./DictionaryItem.vue?vue&type=template&id=2cb12e94&scoped=true"
import script from "./DictionaryItem.vue?vue&type=script&lang=js"
export * from "./DictionaryItem.vue?vue&type=script&lang=js"
import style0 from "./DictionaryItem.vue?vue&type=style&index=0&id=2cb12e94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb12e94",
  null
  
)

export default component.exports